import UBT from 'utils/ubt';

const pageId = 'evbike_moreProblems';
const categoryId = 'evbike';
const base = { pageId, categoryId };
const basicBusinessInfo = {
  isH5: true,
};

export default {
  pageView(isfFirstProblem: string, businessInfo = {}) {
    UBT.pageView({
      ...base,
      businessInfo: {
        ...basicBusinessInfo,
        ...businessInfo,
        isfFirstProblem,
      },
    });
  },
  pageViewOut(isfFirstProblem: string, businessInfo = {}) {
    UBT.pageViewOut({
      ...base,
      businessInfo: {
        ...basicBusinessInfo,
        ...businessInfo,
        isfFirstProblem,
      },
    });
  },
  clickButton(isfFirstProblem: string, businessInfo = {}) {
    UBT.clickButton({
      ...base,
      buttonName: 'evbike_moreProblems_submit',
      businessInfo: {
        ...basicBusinessInfo,
        ...businessInfo,
        isfFirstProblem,
      },
    });
  },
};
